import React from "react";
import Form from "rc-field-form";
import style from "../../index.module.scss";
import FieldWithError from "components/FieldWithError";
import { Button, Icon, Input } from "antd";
import { isTrue } from "service/service";
import { useAtomValue } from "jotai";
import { loginModeAtom, loginUnifySetAtom } from "service/stores/SettingsStore";

export interface FormFields {
    loginName: string;
    pwd: string;
}

export interface AccountModeProps {
    onSubmit(data: FormFields): void;
    loading: boolean;
}

export default function AccountMode({ onSubmit, loading }: AccountModeProps) {
    const loginMode = useAtomValue(loginModeAtom);
    const loginUnifySet = useAtomValue(loginUnifySetAtom);

    return (
        <div>
            {(isTrue(loginMode.normalAuthLogin) ||
                isTrue(loginMode.dynamicCertLogin)) && (
                <Form onFinish={onSubmit} className={style.form}>
                    <div className={style.item}>
                        <div className={style.label}>
                            账号 <i className={style.required}>*</i>
                        </div>

                        <FieldWithError
                            name="loginName"
                            initialValue=""
                            rules={[
                                {
                                    required: true,
                                    message: "请输入账号"
                                }
                            ]}>
                            <Input placeholder="请输入账号" />
                        </FieldWithError>
                    </div>

                    <div className={style.item}>
                        <div className={style.label}>
                            密码 <i className={style.required}>*</i>
                        </div>

                        <FieldWithError
                            name="pwd"
                            initialValue=""
                            rules={[
                                {
                                    required: true,
                                    message: "请输入密码"
                                }
                            ]}>
                            <Input.Password placeholder="请输入密码" />
                        </FieldWithError>
                    </div>

                    <Button
                        type="primary"
                        htmlType="submit"
                        className={style.submit}
                        loading={loading}>
                        登录
                    </Button>
                </Form>
            )}

            <div className={style.footer}>
                {isTrue(loginMode.unifyAuthLogin) && (
                    <Button
                        type="link"
                        className={style.btn}
                        href={loginUnifySet.ssoUrl}>
                        <Icon type="export" /> 统一身份认证入口
                    </Button>
                )}
            </div>
        </div>
    );
}
